/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import AppsLauncherProperties from 'DesignSystem/AppsLauncherProperties/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/Apps/Content/LauncherProps/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let componentValueData = fromData.useDataValue({ viewPath,
context: 'component',
})
let tabPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'patient_id',
})
let onLauncherResolved = fromHelpers.useOnLauncherResolved({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<AppsLauncherProperties
  viewPath={`${viewPath}/AppsLauncherProperties`}
 data="component"
 launcher={componentValueData}
 data="tab.patient_id"
 resourceId={tabPatientIdValueData}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 onLauncherResolved={onLauncherResolved}
/>
{children}
</React.Fragment>)
}